var _circle, _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSingBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#2F67FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_306)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_241_306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 17H17V65H65V17Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_241_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6608 48.1999L54.3808 48.7199C52.7408 49.0999 51.4608 50.3799 51.0808 52.0199L50.5408 54.2999C50.4808 54.5399 50.1408 54.5399 50.0808 54.2999L49.5608 52.0199C49.1808 50.3799 47.9008 49.0999 46.2608 48.7199L43.9808 48.1799C43.7408 48.1199 43.7408 47.7799 43.9808 47.7199L46.2608 47.1999C47.9008 46.8199 49.1808 45.5399 49.5608 43.8999L50.1008 41.6199C50.1608 41.3799 50.5008 41.3799 50.5608 41.6199L51.0808 43.8999C51.4608 45.5399 52.7408 46.8199 54.3808 47.1999L56.6608 47.7399C56.9008 47.7999 56.9008 48.1399 56.6608 48.1999Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6205 53.74L36.0205 56.54C24.5005 62.3 19.8005 57.58 25.5605 46.08L27.3005 42.62C27.7405 41.74 27.7405 40.28 27.3005 39.4L25.5605 35.92C19.8005 24.42 24.5205 19.7 36.0205 25.46L53.1405 34.02C57.9205 36.42 59.7205 39.74 58.5605 42.84",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8809 41H38.6809",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingBtn);
export default __webpack_public_path__ + "static/media/sing-btn.66e9ed390905d9b6248961987a0db8e5.svg";
export { ForwardRef as ReactComponent };